import * as actionTypes from '../actions/types';
import Config from '../models/Config';


export interface ConfigReducerState {
    readonly data: Config[] | null;
    readonly isLoading: boolean;
    readonly isUpdating: string | null;
}

const INITIAL_STATE: ConfigReducerState = {
    data: null,
    isLoading: false,
    isUpdating: null,
}

export default (state: any = INITIAL_STATE, action: any) => {
    switch(action.type) {

        case actionTypes.CONFIG_FETCH:
            return {
                ...state,
                data: action.payload.data,
                isLoading: false,
            }

        case actionTypes.CONFIG_UPDATE:
            return {
                ...state,
                data: (state.data ?? []).map((config: Config) =>
                    config.key === action.payload.key
                        ? { ...config, value: action.payload.value }
                        : config
                ),
            }

        case actionTypes.CONFIG_CHANGE_VALUE:
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            }

        default:
            return state;

    }
}
